var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaviaFlightNrIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.3464011px",
    height: "10.3464011px",
    viewBox: "0 0 10.3464011 10.3464011",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transavia_flight_nr_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia_Flightcards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transavia_flight_nr_icon",
    transform: "translate(-0.750000, -0.903599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.95,1.05 C10.575,0.675 9.6,1.05 8.8125,1.8375 C8.8125,1.8375 8.025,2.625 7.1625,3.4875 L1.5375,2.2125 L0.9,2.8875 L5.325,5.3625 C4.6875,6 3.9,7.0125 3.375,7.6875 L1.125,7.425 L0.75,7.8 L3,9 L4.2,11.25 L4.575,10.875 L4.3125,8.6625 C4.9875,8.1375 5.9625,7.35 6.6375,6.7125 L9.1125,11.1375 L9.7875,10.4625 L8.5125,4.8375 C9.375,3.975 10.1625,3.1875 10.1625,3.1875 C10.95,2.3625 11.325,1.425 10.95,1.05 Z",
    id: "Path",
    fill: "#2800A0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaviaFlightNrIcon);
export default __webpack_public_path__ + "static/media/transavia_flight_nr_icon.0e9f08deeeb4ee7733a3fd1e7f39aff6.svg";
export { ForwardRef as ReactComponent };